export var IssuableStatus;
(function (IssuableStatus) {
    IssuableStatus[IssuableStatus["NORMAL"] = 1] = "NORMAL";
    IssuableStatus[IssuableStatus["HOLD"] = 2] = "HOLD";
    IssuableStatus[IssuableStatus["CANCELLED"] = 3] = "CANCELLED";
})(IssuableStatus || (IssuableStatus = {}));
//# sourceMappingURL=issuable-status.js.map